import { Avatar } from '@tryhackme/thm-ui-components';
import { formatDate } from 'src/common/date';
import { StyledLoading } from 'src/common/components';
import { UserContentProps } from '../../certificate-page.types';
import { StyledUserContent } from './user-content.styles';
export const UserContent = ({
  fullName,
  avatar,
  dateIssued,
  isLoading
}: UserContentProps) => <StyledUserContent data-sentry-element="StyledUserContent" data-sentry-component="UserContent" data-sentry-source-file="user-content.tsx">
    <Avatar avatarSrc={avatar} data-sentry-element="Avatar" data-sentry-source-file="user-content.tsx" />
    <div>
      {isLoading ? <>
          <StyledLoading height="2.2rem" width="12rem" />
          <StyledLoading height="2rem" width="20rem" />
        </> : <>
          <p data-testid="user-name" data-text="user-name">
            {fullName}
          </p>
          {dateIssued && <p>completed on {formatDate(dateIssued)}</p>}
        </>}
    </div>
  </StyledUserContent>;